import carousel from './carousel';

const swiper = document.querySelector('.ProductCarousel.carousel');
export default carousel(swiper, { loop: false });
